import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=cfdfa704&scoped=true&"
import script from "./Task.vue?vue&type=script&lang=ts&"
export * from "./Task.vue?vue&type=script&lang=ts&"
import style0 from "./Task.vue?vue&type=style&index=0&id=cfdfa704&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdfa704",
  null
  
)

export default component.exports